module.exports = __webpack_public_path__ + "img/5.99585909.jpg";